import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonModule } from '@psei/ng/button';
import { MenuModule } from '@psei/ng/menu';
import { TopBarModule } from '@psei/ng/top-bar';
import {
  PseiNgCustomModule,
} from 'projects/ppb-shared-library/src/lib/psei-ng-custom.module';
// tslint:disable-next-line: ordered-imports
import { SharedModule } from '../shared/shared.module';
import { PpbRootComponent } from './ppb-root/ppb-root.component';
import { PpbShareModule } from './shared/ppb-share.module';

@NgModule({
  declarations: [PpbRootComponent],
  imports: [
    CommonModule,
    PseiNgCustomModule,
    RouterModule,
    SharedModule,
    MenuModule,
    PpbShareModule,
    ButtonModule,
    TopBarModule,
  ]
})
export class PpbModule {
}
